<template>
<!--帶關閉彈窗-->
 <transition name="confirm-fade">
    <div v-if="isShow" class="my-confirm" id="confirmPrompt">
      <div v-bind:class="isRed?'confirm-content-wrap-red':'confirm-content-wrap'" >
        <!-- <div :class="{'confirm-content-wrap-red':isRed,'confirm-content-wrap':isWhite}" > -->
        <p class="my-confirm-title">
          <!-- <a href="javascript:;" style="color:#333;"><slot name="header"></slot></a> -->
          <slot name="header"></slot>
        </p>
        <p class="my-confirm-content">
          <!-- <a href="javascript:;" style="color:#333;"><slot name="main"></slot></a> -->
          <slot name="main"></slot>
        </p>
        <p class="my-confirm-bottom">
          <!-- <a href="javascript:;" style="color:#333;"><slot name="main"></slot></a> -->
          <slot name="bottom"></slot>
        </p>
        <button v-if="isShow1" type="button" class="confirm-content-close del-btn-style" @click="onclose"><img class="img-close" src="../assets/images/close.png" :alt="$root.languageData.APP.tiptitle[5]"/></button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props:{
    isShow1:{
      type:Boolean,
      default:true
    },
    isShow:{
      type:Boolean,
      default:false
    },
    isRed:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
    }
  },
  methods: {
    onclose(){
      this.$emit("on-close")
    }
  },mounted(){
  },created(){
  }
 }
</script>
<style lang="scss" scoped>
@media (max-width: 812px) {
   .confirm-content-wrap {
     width: 3.2rem!important;
     overflow: auto;
     z-index: 999!important;
    //  height: 90%;
   }
   .my-confirm-content {
     width: 100%!important;
     margin: 0 0 0.5rem 0!important;
   }
   .my-confirm-bottom {
     width: 100%!important;
     margin: 0 0 0.5rem 0!important;
   }
   .confirm-content-close {
     top: 0.02rem;
     width: 0.22rem;
     height: 0.22rem;
     z-index: 999 !important;
   }
   .img-close {
     width: 100%;
     height: 100%;
     display: block;
   }

}
@media (max-height: 416px){
  .confirm-content-wrap {
     top: 40%!important;
     width: 4rem!important;
     height: 70%!important;
     overflow: auto!important;
     z-index: 999!important;
   }
}
// @media (max-height: 650px) {
//     .confirm-content-wrap {
//     //  width: 3.2rem;
//      overflow: auto;
//      height: 90%;
//    }
// }
</style>




// WEBPACK FOOTER //
// src/components/confirm.vue